export type UnitTransformerUnit =
  | 'millisecond'
  | 'bytes'
  | 'percent'
  | 'score'
  | 'seconds'
  | 'number'
  | 'element'
  | 'thumbnail'
  | string;

export const unitTransformers = (
  value: any,
  unit: UnitTransformerUnit
): any => {
  switch (unit) {
    case 'millisecond':
      return value > 1500
        ? `${(value / 1000).toFixed(1)}s`
        : `${value?.toFixed(0)?.toLocaleString()}ms`;
    case 'bytes':
      if (value < 1024) {
        return `${value?.toFixed(1)}bytes`;
      } else if (value < 1048576) {
        return `${(value / 1024)?.toFixed(1)}KB`;
      } else {
        return `${(value / 1048576)?.toFixed(1)}MB`;
      }
    case 'percent':
      return `${value?.toFixed(1)}%`;
    case 'score':
      return `${(value * 100)?.toFixed(1)}%`;
    case 'seconds':
      return `${value?.toFixed(1)}s`;
    case 'number':
      return value.toLocaleString();
    case 'element':
      return `<${value.tagName.toLowerCase()}>${value.textContent}</${value.tagName.toLowerCase()}>`;
    case 'thumbnail':
      return `<img src="${value}" alt="Thumbnail" />`;
    default:
      return value;
  }
};

export type ThrottlingSettings = {
  cpuSlowdownMultiplier?: number;
  rttMs?: number;
  throughputKbps?: number;
  [key: string]: unknown;
};

export const formatCpuThrottlingDetails = (
  throttling?: ThrottlingSettings | null,
  method?: string | null
): string => {
  if (!throttling || !method) return 'N/A';
  return `
    ${throttling.cpuSlowdownMultiplier}x slowdown (${method})
  `;
};

export const formatThrottlingDetails = (
  throttling?: ThrottlingSettings | null
): string => {
  if (!throttling) return 'N/A';
  return `
    ${throttling.rttMs}ms TCP RTT,

    ${Math.floor(throttling.throughputKbps ?? 0)} kb/s throughput
  `;
};

export const getThrottlingDescription = (method?: string | null): string => {
  switch (method) {
    case 'simulate':
      return 'Slow 4G throttling';
    case 'devtools':
      return 'DevTools throttling';
    case 'provided':
      return 'Provided throttling';
    default:
      return 'Unknown throttling';
  }
};
